import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";

export default function GameDesignAndDevelopment() {
  return (
    <div className="Game-Design-And-Development pt-[160px] sm:pt-0">
      <Helmet>
        <title>Professional Game Design and Development Services | Mean3</title>
        <meta
        name="description"
        content="Looking for game design and development services in Dubai? Let Mean3 bring your vision tolife with expert developers. Reach out to us now!"
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
    </div>
  );
}
